import React from 'react';

import { Button } from '@material-ui/core';
import ButtonGroup from '@material-ui/core/ButtonGroup';

type InputProps = {
  options: Array<SelectOption<string>>;
  selectedValue: string;
  onChange: () => void;
  dataCy?: string;
};

export const UiSliderSelect = (props: InputProps) => {
  const { options, selectedValue, onChange, dataCy } = props;

  return (
    <ButtonGroup
      disableElevation
      variant="contained"
      color="primary"
      className="u-border"
      data-cy={dataCy}
    >
      {options.map((opt, index) => (
        <Button
          key={`option-${opt.value}`}
          className={
            selectedValue === opt.value
              ? 'u-background-primary u-color-white'
              : 'u-background-white u-color-black'
          }
          value={opt.value}
          onClick={onChange}
          data-cy={dataCy ? `${dataCy}-${index}` : undefined}
        >
          {opt.label}
        </Button>
      ))}
    </ButtonGroup>
  );
};
